'use client';
import { QuestionList } from '@/components/question-list';
import RegisterDialog from '@/components/RegisterDialog';
import { Button, buttonVariants } from '@/components/ui/button';
import { useQuestion } from '@/hooks/useQuestion';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/store';
import Link from 'next/link';

const QUESTION_LIMIT = 10;

export default function AddStory() {
  const { getInfiniteQuestionsApi, getAllQuestions } = useQuestion({
    limit: QUESTION_LIMIT,
    type: 'NORMAL',
    source: 'add-story',
  });

  const questions = getAllQuestions();
  const isLoading = getInfiniteQuestionsApi.isLoading;
  const isFetchingNextPage = getInfiniteQuestionsApi.isFetchingNextPage;
  const hasNextPage = getInfiniteQuestionsApi.hasNextPage;
  const user = useAuthStore((state) => state.user);

  return (
    <section className="flex flex-col gap-4 p-8 max-w-4xl w-full mx-auto">
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-2">
          <h1 className="text-base font-bold text-[#24292E]">
            Choose a question
          </h1>
          <p className="text-sm text-gray-500">
            Select a question to add your story
          </p>
        </div>
        {user ? (
          <Link
            href="/ask-question"
            className={cn(
              buttonVariants({ variant: 'default' }),
              'font-bold uppercase'
            )}
          >
            Add a question
          </Link>
        ) : (
          <RegisterDialog
            title="You've got something valuable to say."
            description="Create your free account to ask questions, contribute your experience, and help others navigate change."
            redirectUrl="/ask-question"
          >
            <Button className=" font-bold uppercase">Add a question</Button>
          </RegisterDialog>
        )}
      </div>

      {questions.length === 0 && !isLoading ? (
        <div className="flex items-center justify-center p-20">
          <p className="text-sm text-gray-500">
            No questions found. Please add a question.
          </p>
        </div>
      ) : (
        <QuestionList
          questions={questions}
          isLoading={isLoading}
          isInfiniteScroll={true}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={getInfiniteQuestionsApi.fetchNextPage}
        />
      )}
    </section>
  );
}
